import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { generateChartColors } from '../Helper/chartColorHelper';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function PieChart({ data, height, ...props }) {
  if (!data || data.length === 0) return null;

  const keys = Object.keys(data[0]).filter(k => k !== "label" && k !== "total" && k !== "id");
  const valueKey = keys.includes("value") ? "value" : keys[0];

  const chartData = {
    labels: data.map(d => d.label),
    datasets: [
      {
        data: data.map(d => d[valueKey]),
        backgroundColor: generateChartColors(data.length),
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 12,
          font: { size: 11 },
          padding: 15
        }
      },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        titleColor: '#111',
        bodyColor: '#666',
        borderColor: '#eee',
        borderWidth: 1,
        padding: 10,
        cornerRadius: 8,
      }
    },
  };

  return (
    <div style={{ height: height, width: '100%' }}>
      <Pie options={options} data={chartData} />
    </div>
  );
}
